import {ArrayRow} from './array_row'
import {StatusRow} from './status_row'
import {HeaderRow} from './header_row'
import {DefaultRow} from './default_row'
import {BooleanRow} from './boolean_row'
import {CapitalRow} from './capital_row'
import {DateRow} from './date_row'
import {LinkRow} from './link_row'

export * from './array_row'
export * from './status_row'
export * from './header_row'
export * from './default_row'
export * from './boolean_row'
export * from './capital_row'
export * from './date_row'
export * from './link_row'

export const ROW_FORMATS = [
	{id: 'array', Component: ArrayRow},
	{id: 'status', Component: StatusRow},
	{id: 'subheader', Component: HeaderRow},
	{id: 'default', Component: DefaultRow},
	{id: 'boolean', Component: BooleanRow},
	{id: 'capitalize', Component: CapitalRow},
	{id: 'date', Component: DateRow},
	{id: 'link', Component: LinkRow},
]
